/**
 * 画面描画時にHTMLのタイトルを変更する
 */
export default {
  mounted: function () {
    let baseTitle = process.env.ProjectName
    let { title } = this.$options
    if (title) {
      title = typeof title === 'function' ? title.call(this) : title
      document.title = `${baseTitle} - ${title}`
    } else {
      document.title = `${baseTitle}`
    }
  }
}
